
const TWELVE_HOURS = 12 * 60 * 60 * 1000;

function getItemByName(name: string): string | null {
    const nameLenPlus = name.length + 1;
    return (
        document.cookie
            .split(';')
            .map((c) => c.trim())
            .filter((c) => c.substring(0, nameLenPlus) === `${name}=`)
            .map((c) => decodeURIComponent(c.substring(nameLenPlus)))[0] || null
    );
}
function setItem(name: string, value: string) {
    const twelveHoursFromNow = new Date(new Date().getTime() + TWELVE_HOURS).toUTCString();
    const myDomain = document.location.hostname.split('.').slice(-2).join('.');
    document.cookie = `${name}=${value};domain=.${myDomain};path=/;expires=${twelveHoursFromNow};`;
}

function getWindowList(): string[] {
    const windowListJson = getItemByName('windowlist');
    return windowListJson == null ? [] : JSON.parse(windowListJson);
}

export function setupAppWindowTracking() {
    const suffixInCaseTheresMoreThanOneTab = Math.random().toString(36).substring(2, 15);
    const windowId = `certificationapp-${suffixInCaseTheresMoreThanOneTab}`;
    const windowList = getWindowList();
    windowList.push(windowId);
    setItem('windowlist', JSON.stringify(windowList));
    // remove the window id from the cookie when the tab closes:
    const unload = (): null => {
        const windowListWithoutMe = getWindowList().filter((wid: string) => wid !== windowId);
        setItem('windowlist', JSON.stringify(windowListWithoutMe));
        setItem('lastUnload', new Date().getTime().toString());
        return null;
    };
    window.onbeforeunload = unload;
    window.onunload = unload;
}